import React, { useState, useEffect } from 'react';
import './coursesProgress.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';

import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png'

const apiUrl = process.env.REACT_APP_API_URL;

const CoursesProgress = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseProgress = async () => {
      try {
        const response = await fetch(`${apiUrl}/user/progress`, {
          credentials: 'include',
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Filtram doar cursurile incepute (progres > 0)
          const startedCourses = data.filter(course => course.progress > 0);
          setCourses(startedCourses);
        }
      } catch (error) {
        console.error('Error fetching course progress:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseProgress();
  }, []);

  const getCourseImage = (courseName) => {
    if (courseName.includes('Bazele') || courseName.includes('bazele')) {
      return bazeleconta;
    } else if (courseName.includes('Financiar') || courseName.includes('financiar')) {
      return contafinanciara;
    }
    return bazeleconta; // default
  };

  if (loading) {
    return (
      <div className="courses-progress-card">
        <div className="courses-progress-header">
          <h3 className="courses-progress-title">Cursuri in desfasurare</h3>
        </div>
        <div className="courses-list">
          <p className="loading-message">Se incarca...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="courses-progress-card">
      <div className="courses-progress-header">
        <h3 className="courses-progress-title">Cursuri in desfasurare</h3>
        <Link to="/courses-progress" className="courses-manage-link">Gestioneaza</Link>
      </div>

      {courses.length === 0 ? (
        <div className="courses-empty-state">
          <div className="empty-icon">
            <FontAwesomeIcon icon={faGraduationCap} />
          </div>
          <p className="empty-message">Inca nu ai inceput niciun curs</p>
          <p className="empty-subtitle">Exploreaza cursurile disponibile si incepe sa inveti!</p>
        </div>
      ) : (
        <div className="courses-list">
          {courses.map((course, index) => (
            <div key={index} className="course-item">
              <img src={getCourseImage(course.course_name)} alt="course" className="course-icon-up" />
              <div className="course-info">
                <div className="course-title">{course.course_name}</div>
                <p className="course-status">in progres · {course.progress}%</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <Link to="/cursuri" className="browse-btn">
        <span className='color-userppage-text-buttons'>Vezi toate cursurile</span>
      </Link>
    </div>
  );
};

export default CoursesProgress;
